{
  "Empty": "فارغ"
}
